import { Guid } from '@web/utils';
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { WarehouseReceiptContextOperationsResponse } from './warehouse-receipt-context-operations.response';
import { WarehouseReceiptStatus } from '../../enums/warehouse-receipt-status';

@jsonObject
export class WarehouseReceiptCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly receiptedAt!: Date;

  @jsonMember(String)
  public readonly status!: WarehouseReceiptStatus;

  @jsonMember(WarehouseReceiptContextOperationsResponse)
  public readonly contextOperations!: WarehouseReceiptContextOperationsResponse;

  @jsonArrayMember(String, { name: 'goodsNames' })
  public readonly productNames!: string[];

  @jsonArrayMember(String, { name: 'goodsSkus' })
  public readonly productSkus!: string[];
}
